import { css } from "@emotion/css";
import { Badge } from "@octopusdeploy/design-system-components";
import { SettingsIdValues } from "@octopusdeploy/octopus-server-client";
import type { TypeMetadata, PropertyMetadata, SettingsId } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { EditSettingsPage } from "~/areas/configuration/components/Settings/EditSettingsPage";
import DynamicForm from "~/components/DynamicForm/DynamicForm";
import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
import { useIsLicensedFeatureEnabled } from "~/components/LicensedFeature/useIsLicensedFeatureEnabled";
import { FormSectionHeading } from "~/components/form";
const isScimProperty = (property: PropertyMetadata): boolean => property.DisplayInfo.Category == "SCIM";
const withOnlyScimProperties = ({ Name, Properties }: TypeMetadata): TypeMetadata => ({
    Name,
    Properties: Properties.filter(isScimProperty),
});
const withoutScimProperties = ({ Name, Properties }: TypeMetadata): TypeMetadata => ({
    Name,
    Properties: Properties.filter((p) => !isScimProperty(p)),
});
// Add isScimLicensed as a prop
interface EditAzureADSettingsPageProps {
    settingId: SettingsId;
    isScimLicensed: boolean;
}
class EditAzureADSettingsPage extends EditSettingsPage {
    declare props: EditAzureADSettingsPageProps;
    override renderParentSection(): React.JSX.Element | undefined {
        if (!this.state.types) {
            return undefined;
        }
        return (<div>
                <DynamicForm description={this.state.types.Description} types={this.state.types.Types.map(withoutScimProperties)} values={this.state.values} onChange={(c) => {
                this.setState({
                    settingsMetadata: this.state.settingsMetadata,
                    types: this.state.types,
                    values: c,
                });
            }}/>
                {isFeatureToggleEnabled("EntraIdScimFeatureToggle") && this.props.isScimLicensed && (<>
                        <FormSectionHeading title={<div className={sectionHeadingTitleLayout}>
                                    <span>System for Cross-domain Identity Management (SCIM)</span>
                                    <Badge size="small" variant="neutral" label="Early Access"></Badge>
                                </div>}/>
                        <DynamicForm description="Allow Azure Active Directory to manage users and groups. [Learn more](https://g.octopushq.com/ScimAzureAD)." types={this.state.types.Types.map(withOnlyScimProperties)} values={this.state.values} onChange={(c) => {
                    this.setState({
                        settingsMetadata: this.state.settingsMetadata,
                        types: this.state.types,
                        values: c,
                    });
                }}/>
                    </>)}
            </div>);
    }
}
const sectionHeadingTitleLayout = css({
    display: "flex",
    gap: "0.5rem",
    alignItems: "center",
});
export function AzureADSettingsPage() {
    const isScimLicensed = useIsLicensedFeatureEnabled("Scim") || isFeatureToggleEnabled("ScimBypassEntitlementFeatureToggle");
    return <EditAzureADSettingsPage settingId={SettingsIdValues.AzureAD} isScimLicensed={isScimLicensed}/>;
}
